module.exports = __webpack_public_path__ + "img/Left Back Door.a187fe07.png";